<template>
  <teleport v-if="isOpen" to="body">
    <!-- <transition name="popup-infobox"> -->
    <a-focus-trap initial-focus=".popup-infobox__button-close">
      <section
        v-bind="$attrs"
        :id="`popup-infobox-${id}`"
        :class="popupClassName"
        class="popup-infobox"
        role="dialog"
        aria-labelledby="infobox-label"
        @keydown.esc="close"
      >
        <span id="infobox-label" class="a-visually-hidden">{{ heading }}</span>

        <button class="popup-infobox__button-close" @click="close">
          <dpc-icon
            class="popup-infobox__icon-close"
            icon="close"
            label-path="close"
          ></dpc-icon>
        </button>

        <slot />
      </section>
    </a-focus-trap>
    <!-- </transition> -->
  </teleport>
</template>

<script>
import { useStore } from 'vuex';
import { toRefs, computed, watch, onMounted } from 'vue';
import { useStorage } from '@vueuse/core';

export default {
  props: {
    id: {
      type: String,
    },
    heading: {
      type: String,
    },
    openOnLoad: {
      type: Boolean,
      default: false,
    },
    openOnLoadConfig: {
      type: Object,
      default() {
        return {
          persist: 'sessionStorage',
        };
      },
    },
    popupClassName: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const store = useStore();
    const { id, openOnLoad, openOnLoadConfig } = toRefs(props);

    const isOpen = computed(() => {
      return store.getters['popupInfobox/isOpen']({
        instanceKey: id.value,
      });
    });

    const close = () => {
      store.dispatch('popupInfobox/close', {
        instanceKey: id.value,
      });
    };

    watch(isOpen, isOpen => {
      const html = document.querySelector('html');
      html.classList[isOpen ? 'add' : 'remove'](
        'is-locked-by-dpc-popup-infobox'
      );
    });

    onMounted(() => {
      store.dispatch('popupInfobox/newInstance', {
        instanceKey: id.value,
      });

      if (openOnLoad.value) {
        if (openOnLoadConfig.value?.persist) {
          const cancelOpening = useStorage(
            `popup-infobox-opened-${id.value}`,
            false,
            window[openOnLoadConfig.value.persist]
          );
          if (cancelOpening.value) return;
          cancelOpening.value = true;
        }

        store.dispatch('popupInfobox/open', {
          instanceKey: id.value,
        });
      }
    });

    return { isOpen, close };
  },
};
</script>
